import { IOrderModifier, OrderModifier } from './OrderModifier';

export interface IOrderModifierGroup {
    readonly modifierGroupId: number;
    readonly name: string;
    readonly modifiers: IOrderModifier[];
}

export interface IOrderModifierGroupData {
    modifierGroupId: number;
    name: string;
    modifiers?: OrderModifier[];
}

export class OrderModifierGroup implements IOrderModifierGroup {
    readonly modifierGroupId: number;
    readonly name: string;
    readonly modifiers: OrderModifier[];

    constructor(data: IOrderModifierGroupData) {
        this.modifierGroupId = data.modifierGroupId;
        this.name = data.name;
        this.modifiers = data.modifiers ?? [];
    }

    toJSON(): IOrderModifierGroup {
        return {
            modifierGroupId: this.modifierGroupId,
            name: this.name,
            modifiers: this.modifiers.map(m => m.toJSON()),
        };
    }

    static fromJSON(data: Record<string, unknown>): OrderModifierGroup {
        if (typeof data.modifierGroupId !== 'number') {
            throw new Error("OrderModifierGroup.fromJSON: modifierGroupId must be a number");
        }
        if (typeof data.name !== 'string') {
            throw new Error("OrderModifierGroup.fromJSON: name must be a string");
        }

        const modifiers = Array.isArray(data.modifiers)
            ? data.modifiers.map((m: any) => OrderModifier.fromJSON(m))
            : [];

        return new OrderModifierGroup({
            modifierGroupId: data.modifierGroupId,
            name: data.name,
            modifiers,
        });
    }
}
